module.exports = __webpack_public_path__ + "img/dmlogo.04815a3b.svg";